export async function importAesKey(base64Key: string): Promise<CryptoKey> {
  const keyBytes = base64ToBytes(base64Key);

  // @ts-ignore
  return window.crypto.subtle.importKey('raw', keyBytes, { name: 'AES-CBC' }, false, [
    'encrypt',
    'decrypt',
  ]);
}

export async function encrypt(
  keyPromise: Promise<CryptoKey>,
  iv: Uint8Array,
  text: string
): Promise<string> {
  const key = await keyPromise;
  const data = new TextEncoder().encode(text);
  const cipherBuf = await crypto.subtle.encrypt({ name: 'AES-CBC', iv: iv as BufferSource }, key, data);
  return bytesToBase64(new Uint8Array(cipherBuf));
}

export async function createObfuscatedPayload<T>(
  payload: T,
  keyPromise: Promise<CryptoKey>,
  iv: Uint8Array
): Promise<string> {
  return encrypt(keyPromise, iv, JSON.stringify(payload));
}

// Base64 <-> bytes helpers that work in browsers
export function base64ToBytes(b64: string): Uint8Array {
  const bin = atob(b64);
  const out = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) {
    out[i] = bin.charCodeAt(i);
  }
  return out;
}

export function bytesToBase64(bytes: Uint8Array): string {
  let bin = '';
  for (let i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
  return btoa(bin);
}
